export default __webpack_public_path__ + "Enhance-Fitness-white.svg";